<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>


    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <el-form-item v-if="isBlogAdmin" slot="buttonSlot">
          <el-button type="warning" icon="el-icon-upload2" @click="openSimulateDialog">模拟上报</el-button>
        </el-form-item>
      </toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- <el-table-column type="index" width="80"></el-table-column> -->
        <el-table-column prop="CardId" label="卡号" width></el-table-column>
        <el-table-column prop="UserName" label="姓名" width></el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width></el-table-column>
        <el-table-column prop="KqTerminalId" label="终端标识" width></el-table-column>
        <el-table-column prop="TouchTime" label="刷卡时间" width></el-table-column>
        <el-table-column prop="ReportTime" label="上报时间" width></el-table-column>
        <el-table-column prop="TouchType" label="刷卡类型" width></el-table-column>

        <el-table-column prop="KqImageFile" label="媒体文件" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.KqImageFile" />
          </template>
        </el-table-column>
        <el-table-column prop="ProcessResult" label="处理结果" width="100px"></el-table-column>

        <!-- <el-table-column prop="ModifyBy" header-align="center" align="center" label="推送" width="150px">
          <template slot-scope="scope">
            <el-button type="text" @click="getProgress(scope.row)">{{ scope.row.ModifyBy }}</el-button>
          </template>
        </el-table-column> -->

        <el-table-column label="联动视频" align="center" header-align="center" width="120px">
          <template slot-scope="scope">
            <div v-if="scope.row.hasVideo" class="media-thumb" @click="playVideo(scope.row)">
              <video
                v-if="getAttendanceVideoThumbSrc(scope.row)"
                :src="getAttendanceVideoThumbSrc(scope.row)"
                class="media-thumb-video"
                preload="metadata"
              />
              <div v-else class="media-thumb-video media-thumb-placeholder"></div>
              <span class="media-thumb-play">
                <i class="el-icon-video-play"></i>
              </span>
            </div>
            <span v-else-if="scope.row.videoMediaPending" class="video-media-pending">加载中</span>
            <span v-else style="color: #c0c4cc; font-size: 12px;">无视频</span>
          </template>
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>

      <!-- 视频播放弹窗 -->
      <el-dialog :title="videoDialogTitle" :visible.sync="videoDialogVisible" width="600px" @close="closeVideo" append-to-body>
        <div style="text-align: center;">
          <video v-if="currentVideoUrl" :src="currentVideoUrl" controls autoplay style="width: 100%; max-height: 400px;"></video>
          <div v-else style="padding: 20px 0; color: #909399;">正在载入视频...</div>
        </div>
      </el-dialog>
    </section>

    <!-- 模拟上报弹窗：仅 blogadmin / admin -->
    <el-dialog
      title="模拟学生考勤上报"
      :visible.sync="simulateVisible"
      width="520px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="simulateForm" :model="simulateForm" :rules="simulateRules" label-width="96px" size="small">
        <el-form-item label="考勤终端" prop="KqTerminalId">
          <el-select
            v-model="simulateForm.KqTerminalId"
            filterable
            clearable
            placeholder="选择考勤终端"
            style="width: 100%"
            @change="onTerminalChange"
          >
            <el-option
              v-for="d in terminalOptions"
              :key="d.KqTerminalId"
              :label="(d.TerminalName || d.KqTerminalId) + '（' + d.KqTerminalId + '）'"
              :value="d.KqTerminalId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学生" prop="UserId">
          <el-select
            v-model="simulateForm.UserId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入姓名/学号/卡号搜索（至少2字）"
            :remote-method="searchStudents"
            :loading="studentLoading"
            :no-data-text="studentSearchHint"
            style="width: 100%"
            @change="onStudentChange"
            @visible-change="onStudentSelectVisible"
          >
            <el-option
              v-for="s in studentOptions"
              :key="s.Id"
              :label="formatStudentOption(s)"
              :value="String(s.Id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="方向" prop="TouchType">
          <el-radio-group v-model="simulateForm.TouchType">
            <el-radio label="in">进入</el-radio>
            <el-radio label="out">离开</el-radio>
            <el-radio label="inout">出入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="刷卡时间" prop="TouchTime">
          <el-date-picker
            v-model="simulateForm.TouchTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择刷卡时间"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="simulateVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="simulateLoading" @click="submitSimulate">提交上报</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getKqtGatherRawHistoryListPage,
  getSendProgress,
  exportKqtGatherRawHistory,
  getKqtDeviceTerminalListPage,
  simulateKqtReportAttendance,
} from '../../api/modules/attendance';
import { getStudentInfoListPage } from '../../api/modules/personnel';
import { BaseApiUrl } from '../../api/base';
import { getSchoolDepartmentTree } from '../../api/modules/department';
import {
  applyAttendanceVideosToRows,
  getAttendanceMediaBaseUrl,
  resolveAttendanceVideoMonthFromDate,
} from "../../utils/attendanceVideo";
import {
  batchResolveOssMediaUrls,
  isAliyunOssHttpsUrl,
  resolveMediaUrl,
  resolvePlayableMediaUrl,
  stripOssUrlQuery,
} from "../../utils/mediaUrl";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import superAdminMixin from '../../mixins/superAdminMixin'

export default {
  components: { Toolbar, DepartmentPane },
  mixins: [superAdminMixin],
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '姓名',
          key: 'name',
        },
        {
          label: '卡号',
          key: 'cardId',
        },
        {
          label: '终端标识',
          key: 'kqTerminalId',
        },
        {
          label: '开始日期',
          key: 'date',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      BaseApiUrl: BaseApiUrl, //网络前缀
      videoDialogVisible: false,
      currentVideoUrl: "",
      currentVideoTouchTime: "",
      schoolSchId: "", // 存储与当前 activeSchoolId 对应的真实学校 SchId (如 sch_100)
      videoCheckSeq: 0,
      // 联动视频封面渐进加载间隔（毫秒）
      videoThumbStaggerMs: 80,
      // 抓拍图预签延后，避免与联动视频同时抢带宽
      kqImagePrefetchDeferMs: 400,
      currentUser: null,
      simulateVisible: false,
      simulateLoading: false,
      terminalOptions: [],
      studentOptions: [],
      studentLoading: false,
      studentSearchHint: '请输入关键字搜索',
      lastStudentQuery: '',
      simulateForm: {
        KqTerminalId: '',
        UserId: '',
        CardId: '',
        TouchType: 'in',
        TouchTime: ''
      },
      simulateRules: {
        KqTerminalId: [{ required: true, message: '请选择考勤终端', trigger: 'change' }],
        UserId: [{ required: true, message: '请选择学生', trigger: 'change' }],
        TouchType: [{ required: true, message: '请选择方向', trigger: 'change' }],
        TouchTime: [{ required: true, message: '请选择刷卡时间', trigger: 'change' }]
      }
    };
  },
  computed: {
    videoDialogTitle() {
      const touchTime = String(this.currentVideoTouchTime || '').trim();
      return touchTime ? `考勤视频播放 - ${touchTime}` : '考勤视频播放';
    },
    schoolDepartmentId() {
      return this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId') || this.DepartmentId || ''
    }
  },
  watch: {
    // 监听全局 Vuex 活跃学校 ID 的变化，动态解析匹配真实的 SchId (如 sch_100)
    '$store.state.activeSchoolId': {
      handler(newSchoolId) {
        if (newSchoolId && newSchoolId !== '0' && newSchoolId !== 0) {
          getSchoolDepartmentTree({ pid: 0, type: 1 }).then(res => {
            let matchedSchId = null;
            if (res.data && res.data.response) {
              matchedSchId = this.findSchIdByValue(res.data.response, newSchoolId);
            }
            // 优先使用查到的 SchId，若不存在则以 newSchoolId 转换字符串兜底
            this.schoolSchId = matchedSchId || String(newSchoolId);
          }).catch(err => {
            console.error('根据全局 ID 匹配真实学校 SchId 失败', err);
            this.schoolSchId = String(newSchoolId);
          })
        } else {
          this.schoolSchId = '';
        }
      },
      immediate: true
    }
  },
  methods: {

    getProgress(row) {
      if (row.ModifyBy) {
        var arr = row.ModifyBy.split('|');
        if (arr.length == 2) {
          if (arr[1] == "0") {
            this.$message({
              message: "推送失败【" + arr[0] + "】",
              type: "error",
            });
          } else {
            let para = {
              departmentId: row.DepartmentId,
              taskId: arr[0]
            };
            getSendProgress(para)
              .then((res) => {
                if (res.data.success) {
                  this.$message({
                    message: "推送成功",
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.data.msg || '查询失败',
                    type: "error",
                  });
                }
              })
              .catch(() => {
                this.$message.error('网络错误');
              });
          }
        } else {
          this.$message({
            message: "推送失败【" + arr[0] + "】",
            type: "error",
          });
        }
      }
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.page = 1;
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    /**
     * 从 Blob 响应体解析错误信息：优先 JSON 的 msg；否则在排除 xlsx(zip) 魔数后回退为纯文本。最后更新：2026-04-05
     */
    async parseBlobJsonMsg(blob) {
      if (!(blob instanceof Blob)) return null;
      try {
        const head = await blob.slice(0, 4).arrayBuffer();
        const u8 = new Uint8Array(head);
        if (u8.length >= 2 && u8[0] === 0x50 && u8[1] === 0x4b) return null;
        const text = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsText(blob);
        });
        const trimmed = (text || '').trim();
        if (!trimmed) return null;
        try {
          const j = JSON.parse(trimmed);
          return j.msg || j.message || null;
        } catch (e) {
          if (trimmed.length <= 2000) return trimmed;
          return null;
        }
      } catch (e) {
        return null;
      }
    },
    // 默认带日期范围，走后端 TouchTime 闭区间索引，避免无日期扫全表。最后更新：2026-06-11
    ensureDateRange() {
      const today = util.formatDate.format(new Date(), 'yyyy-MM-dd')
      if (!this.filters.date) {
        this.$set(this.filters, 'date', today)
      }
      if (!this.filters.endDate) {
        this.$set(this.filters, 'endDate', this.filters.date || today)
      }
    },
    // 获取列表（与消费记录页一致：success 校验、异常与 loading）。最后更新：2026-04-05
    handleQuery() {
      this.ensureDateRange()
      const para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      this.listLoading = true;
      getKqtGatherRawHistoryListPage(para)
        .then(async (res) => {
          const body = res && res.data;
          if (!body || body.success === false) {
            this.users = [];
            this.total = 0;
            this.$message.error((body && body.msg) || '查询失败');
            return;
          }
          const pg = body.response;
          if (pg && Array.isArray(pg.data)) {
            if (pg.dataCount != null && pg.dataCount >= 0) {
              this.total = pg.dataCount;
            }
            const rows = pg.data.map(item => {
              const hasKqVideoFile = !!String(item.KqVideoFile || item.kqVideoFile || '').trim();
              return {
                ...item,
                hasVideo: false,
                videoUrl: "",
                videoThumbUrl: "",
                videoMediaPending: !hasKqVideoFile,
              };
            });
            this.applyKqVideoFileToRows(rows);
            this.users = rows;
            this.scheduleAttendanceVideoMediaLoad(rows);
          } else {
            this.users = [];
            this.total = 0;
          }
        })
        .catch((err) => {
          this.users = [];
          this.total = 0;
          let msg = '网络错误';
          const d = err.response && err.response.data;
          if (d && typeof d === 'object' && !(d instanceof Blob) && d.msg) {
            msg = d.msg;
          } else if (d instanceof Blob) {
            this.parseBlobJsonMsg(d).then((m) => {
              if (m) this.$message.error(m);
              else this.$message.error(msg);
            });
            return;
          } else if (typeof d === 'string') {
            try {
              const j = JSON.parse(d);
              if (j.msg) msg = j.msg;
            } catch (e) {
              /* ignore */
            }
          }
          this.$message.error(msg);
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    async exportExcel() {
      const para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      const fileName = '考勤记录';
      try {
        const response = await exportKqtGatherRawHistory(para);
        if (!response || typeof response.status !== 'number' || !response.config) {
          const msg =
            (response && (response.msg || response.message)) || '导出失败';
          this.$message.error(msg);
          return;
        }
        const ct =
          (response.headers &&
            (response.headers['content-type'] || response.headers['Content-Type'])) ||
          '';
        if (ct.includes('application/json')) {
          const msg = await this.parseBlobJsonMsg(response.data);
          this.$message.error(msg || '导出失败');
          return;
        }
        if (!response.data || (response.data.size != null && response.data.size === 0)) {
          this.$message.warning('导出数据为空');
          return;
        }
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        const blob = error.response && error.response.data;
        if (blob instanceof Blob) {
          const msg = await this.parseBlobJsonMsg(blob);
          this.$message.error(msg || '导出失败');
          return;
        }
        const d = error.response && error.response.data;
        if (d && typeof d === 'string' && d.trim()) {
          try {
            const j = JSON.parse(d);
            this.$message.error(j.msg || j.message || d);
          } catch (e) {
            this.$message.error(d.trim());
          }
          return;
        }
        if (d && typeof d === 'object' && d.msg) {
          this.$message.error(d.msg);
          return;
        }
        console.error('下载失败:', error);
        this.$message.error('导出失败，请稍后重试');
      }
    },
    // 递归寻找与全局学校 ID 匹配的学校节点，并返回其真实的 SchId 字段值
    findSchIdByValue(node, schoolId) {
      if (!node) return null;
      // 确保比对时均转为字符串，规避类型不一致导致匹配失败
      if (String(node.value) === String(schoolId)) {
        const orgType = String(node.DeptOrgType || node.deptOrgType || '').toLowerCase();
        if (orgType === 'school' || orgType === 'affiliateschool') {
          return node.SchId || node.schId || null;
        }
      }
      if (node.children && node.children.length) {
        for (let i = 0; i < node.children.length; i++) {
          const schId = this.findSchIdByValue(node.children[i], schoolId);
          if (schId) return schId;
        }
      }
      return null;
    },
    resolveAttendanceVideoSchoolId() {
      return this.schoolSchId
        || this.$store.state.activeSchoolId
        || window.localStorage.getItem('activeSchoolId')
        || '';
    },
    resolveAttendanceVideoMonth() {
      return resolveAttendanceVideoMonthFromDate(this.filters && this.filters.date);
    },
    /**
     * 优先使用考勤表 KqVideoFile（OSS 或本机相对路径）。最后更新：2026-07-02
     */
    applyKqVideoFileToRows(rows) {
      const mediaBaseUrl = getAttendanceMediaBaseUrl();
      (rows || []).forEach((row, index) => {
        const raw = String(row.KqVideoFile || row.kqVideoFile || '').trim();
        if (!raw) return;
        const fullUrl = /^https?:\/\//i.test(raw)
          ? raw
          : (raw.startsWith('/') ? mediaBaseUrl + raw : resolveMediaUrl(raw));
        this.$set(rows[index], 'hasVideo', true);
        this.$set(rows[index], 'videoUrl', fullUrl);
        this.$set(rows[index], 'videoMediaPending', false);
      });
    },
    /**
     * 列表缩略图地址：OSS 用预签名 URL，本机/网关直链用原地址。最后更新：2026-07-02
     */
    getAttendanceVideoThumbSrc(row) {
      if (!row || !row.hasVideo) return '';
      const thumb = String(row.videoThumbUrl || '').trim();
      if (thumb) return thumb;
      const url = String(row.videoUrl || '').trim();
      if (!url) return '';
      if (isAliyunOssHttpsUrl(url)) return '';
      return url;
    },
    /**
     * 渐进预取 OSS 联动视频封面（批量签名、逐条展示，减轻扎堆感）。最后更新：2026-07-02
     */
    async prefetchAttendanceVideoThumbsProgressive(rows, seq) {
      const list = rows || this.users;
      if (!list || !list.length) return;

      const schoolId = this.resolveAttendanceVideoSchoolId() || this.DepartmentId;
      if (!schoolId) return;

      const pendingRows = [];
      const urls = [];
      list.forEach((row, index) => {
        const url = String(row.videoUrl || '').trim();
        if (!row.hasVideo || !url || !isAliyunOssHttpsUrl(url) || row.videoThumbUrl) return;
        pendingRows.push({ index, stable: stripOssUrlQuery(url) });
        if (!urls.includes(url)) urls.push(url);
      });
      if (!pendingRows.length) return;

      try {
        const signedMap = await batchResolveOssMediaUrls(urls, schoolId, { inline: true });
        for (let i = 0; i < pendingRows.length; i++) {
          if (seq != null && seq !== this.videoCheckSeq) return;
          const item = pendingRows[i];
          const signed = signedMap[item.stable];
          if (signed) {
            this.$set(list[item.index], 'videoThumbUrl', signed);
          }
          if (i < pendingRows.length - 1 && this.videoThumbStaggerMs > 0) {
            await this.delay(this.videoThumbStaggerMs);
          }
        }
      } catch (e) {
        console.warn('[KqtHistoryList] prefetchAttendanceVideoThumbsProgressive', e);
      }
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    /**
     * 异步加载联动视频封面（不阻塞列表首屏，串行 + 渐进）。最后更新：2026-07-02
     */
    scheduleAttendanceVideoMediaLoad(rows) {
      const seq = ++this.videoCheckSeq;
      const list = rows || this.users;
      if (!list || !list.length) return;

      (async () => {
        try {
          await this.delay(50);
          if (seq !== this.videoCheckSeq) return;

          // 已有 KqVideoFile 的 OSS 行先渐进出封面
          await this.prefetchAttendanceVideoThumbsProgressive(list, seq);
          if (seq !== this.videoCheckSeq) return;

          await this.checkVideosStatus(list);
          if (seq !== this.videoCheckSeq) return;

          // 网关兜底查到的视频再补一轮封面
          await this.prefetchAttendanceVideoThumbsProgressive(list, seq);
        } catch (e) {
          console.warn('[KqtHistoryList] scheduleAttendanceVideoMediaLoad', e);
        } finally {
          if (seq !== this.videoCheckSeq) return;
          this.clearAttendanceVideoMediaPending(list);
        }
      })();

      setTimeout(() => {
        if (seq !== this.videoCheckSeq) return;
        this.prefetchListOssMedia(list, 'KqImageFile');
      }, this.kqImagePrefetchDeferMs);
    },
    clearAttendanceVideoMediaPending(rows) {
      (rows || []).forEach((row, index) => {
        if (!row.videoMediaPending) return;
        this.$set(rows[index], 'videoMediaPending', false);
      });
    },
    /**
     * 批量检测联动视频（无 KqVideoFile 的行走媒体网关兜底）。最后更新：2026-07-02
     */
    async checkVideosStatus(rows) {
      const list = rows || this.users;
      if (!list || !list.length) return;

      const schoolId = this.resolveAttendanceVideoSchoolId();
      if (!schoolId) {
        list.forEach((item, index) => {
          if (item.KqVideoFile || item.kqVideoFile) return;
          this.$set(list[index], 'hasVideo', false);
          this.$set(list[index], 'videoUrl', '');
          this.$set(list[index], 'videoMediaPending', false);
        });
        return;
      }

      const needCheck = list.filter((row) => {
        const raw = String(row.KqVideoFile || row.kqVideoFile || '').trim();
        return !raw;
      });
      if (!needCheck.length) {
        this.clearAttendanceVideoMediaPending(list);
        return;
      }

      const month = this.resolveAttendanceVideoMonth();
      try {
        await applyAttendanceVideosToRows(this, needCheck, schoolId, { month });
      } catch (e) {
        console.warn('[KqtHistoryList] checkVideosStatus', e);
      }
    },
    async playVideo(rowOrUrl) {
      const url = typeof rowOrUrl === 'string' ? rowOrUrl : (rowOrUrl && rowOrUrl.videoUrl);
      if (!url) return;
      const schoolId = this.resolveAttendanceVideoSchoolId() || this.DepartmentId;
      this.currentVideoTouchTime = typeof rowOrUrl === 'string'
        ? ''
        : String((rowOrUrl && (rowOrUrl.TouchTime || rowOrUrl.touchTime)) || '').trim();
      try {
        this.videoDialogVisible = true;
        this.currentVideoUrl = '';
        this.currentVideoUrl = await resolvePlayableMediaUrl(url, schoolId);
      } catch (e) {
        this.videoDialogVisible = false;
        this.$message.error((e && e.message) || '无法播放视频');
      }
    },
    closeVideo() {
      this.currentVideoUrl = '';
      this.currentVideoTouchTime = '';
    },
    formatNow() {
      const d = new Date()
      const p = (n) => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },
    formatStudentOption(s) {
      const name = s.StuName || s.Name || ''
      const card = this.resolveStudentCard(s) || '无卡'
      const no = s.StuCode || s.StuNo || s.StudentNo || ''
      return no ? `${name} / ${no} / ${card}` : `${name} / ${card}`
    },
    /** 主卡号优先，否则取附属卡 */
    resolveStudentCard(s) {
      if (!s) return ''
      if (s.CardNumber) return String(s.CardNumber).trim()
      const domains = s.domains || s.Domains || []
      if (domains.length) {
        const first = domains[0]
        const v = (first && (first.value || first.Value || first.cardId || first.CardId)) || ''
        if (v) return String(v).trim()
      }
      if (s.OtherCardNo) {
        const part = String(s.OtherCardNo).split(/[，,]/)[0]
        return (part || '').trim()
      }
      return ''
    },
    async openSimulateDialog() {
      if (!this.isBlogAdmin) return
      this.simulateForm = {
        KqTerminalId: '',
        UserId: '',
        CardId: '',
        TouchType: 'in',
        TouchTime: this.formatNow()
      }
      this.studentOptions = []
      this.lastStudentQuery = ''
      this.studentSearchHint = '请输入关键字搜索'
      this.simulateVisible = true
      await this.loadTerminals()
    },
    onStudentSelectVisible(visible) {
      if (!visible) return
      if (!this.studentOptions.length) {
        this.studentSearchHint = '请输入姓名/学号/卡号（至少2字）'
      }
    },
    async loadTerminals() {
      const res = await getKqtDeviceTerminalListPage({
        page: 1,
        intPageSize: 200,
        type: '0',
        departmentId: this.schoolDepartmentId || undefined
      })
      this.terminalOptions = (res.data && res.data.response && res.data.response.data) || []
      if (!this.simulateForm.KqTerminalId && this.terminalOptions.length) {
        this.simulateForm.KqTerminalId = this.terminalOptions[0].KqTerminalId
        this.onTerminalChange(this.simulateForm.KqTerminalId)
      }
    },
    onTerminalChange(id) {
      const d = (this.terminalOptions || []).find(x => x.KqTerminalId === id)
      if (d && d.TouchTypeDirection && ['in', 'out', 'inout'].includes(d.TouchTypeDirection)) {
        this.simulateForm.TouchType = d.TouchTypeDirection
      }
    },
    /**
     * 远程搜索学生：必须关键字，最多返回 30 条
     */
    async searchStudents(query) {
      const q = (query || '').trim()
      this.lastStudentQuery = q
      if (q.length < 2) {
        this.studentOptions = []
        this.studentSearchHint = q ? '请再输入至少1个字' : '请输入姓名/学号/卡号（至少2字）'
        return
      }
      this.studentLoading = true
      this.studentSearchHint = '无匹配学生'
      try {
        const para = {
          page: 1,
          intPageSize: 30,
          departmentId: this.schoolDepartmentId || this.DepartmentId || undefined
        }
        if (/^\d+$/.test(q)) para.cardNo = q
        else para.stuName = q
        const res = await getStudentInfoListPage(para)
        const list = (res.data && res.data.response && res.data.response.data) || []
        this.studentOptions = list
        if (!list.length) this.studentSearchHint = '无匹配学生'
      } finally {
        this.studentLoading = false
      }
    },
    onStudentChange(userId) {
      const s = (this.studentOptions || []).find(x => String(x.Id) === String(userId))
      this.simulateForm.CardId = this.resolveStudentCard(s)
    },
    submitSimulate() {
      this.$refs.simulateForm.validate(async (ok) => {
        if (!ok) return
        if (!this.simulateForm.UserId && !this.simulateForm.CardId) {
          this.$message.warning('请选择学生')
          return
        }
        this.simulateLoading = true
        try {
          const touchTime = this.simulateForm.TouchTime
          const res = await simulateKqtReportAttendance({
            UserId: this.simulateForm.UserId || '',
            CardId: this.simulateForm.CardId || '',
            KqTerminalId: this.simulateForm.KqTerminalId,
            TouchType: this.simulateForm.TouchType,
            TouchTime: touchTime,
            ReportTime: touchTime,
            UserRole: 'student',
            BusinessDesc: '模拟上报'
          }, { skipCache: true })
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '模拟上报成功')
            this.simulateVisible = false
            this.handleQuery()
          } else {
            this.$message.error((res.data && res.data.msg) || '模拟上报失败')
          }
        } catch (e) {
          this.$message.error('模拟上报请求失败')
        } finally {
          this.simulateLoading = false
        }
      })
    }
  },
  mounted() {
    if (window.localStorage.user) {
      try {
        this.currentUser = JSON.parse(window.localStorage.user)
      } catch (e) {
        this.currentUser = null
      }
    }
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 视频封面预览卡片容器样式 */
.media-thumb {
  position: relative;
  width: 88px;
  height: 52px;
  margin: 0 auto;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

/* 鼠标悬浮微调位移及阴影加深动效 */
.media-thumb:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.16);
}

/* 视频渲染样式（使用 object-fit 铺满容器） */
.media-thumb-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #000;
}

.media-thumb-placeholder {
  background: linear-gradient(135deg, #2c3e50, #1a252f);
}

.video-media-pending {
  color: #c0c4cc;
  font-size: 12px;
}

/* 半透明黑色背景与白色播放图标层 */
.media-thumb-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 22px;
}
</style>
